<template>
    <div>
        <h1>Page Not Found</h1>
    </div>
</template>

<script>
export default {
    name: 'EticketAgentCreateTicket',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>

</style>